<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoEditar">
                <form #f="ngForm" name="form" novalidate (ngSubmit)="atualizar()">
                    <div class="formgroup">
                        <div class="flex justify-content-center" *ngIf="loading">
                            <p-progressSpinner></p-progressSpinner>
                        </div>
                        <div *ngIf="messagemVisivel" class="w-full mb-5">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="p-fluid p-formgrid grid" *ngIf="adicionalEDesconto">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="profissionalId">Profissional</label>
                                <p-dropdown [options]="profissionais" optionLabel="usuario.nome" optionValue="id" [filter]="true"
                                emptyFilterMessage="Nenhum registro" placeholder="Selecione" name="profissionalId"
                                ngModel #profissionalId="ngModel" [(ngModel)]="adicionalEDesconto.profissionalId">
                                </p-dropdown>
                            </div>
                            <div class="field col-12 md:col-4">
                                <label htmlFor="codigoPlanoConta">Referente</label>
                                <p-dropdown [options]="contas" optionLabel="descricao" optionValue="codigo" [filter]="true"
                                emptyFilterMessage="Nenhum registro" placeholder="Selecione" name="codigoPlanoConta"
                                ngModel #codigoPlanoConta="ngModel" [(ngModel)]="adicionalEDesconto.codigoPlanoConta">
                                </p-dropdown>
                            </div>
                            <div class="field col-12 md:col-4">
								<label htmlFor="descricao">Descrição</label>
								<input type="text" pInputText placeholder="Digita descrição" name="descricao"
									ngModel #descricao="ngModel" [(ngModel)]="adicionalEDesconto.descricao"/>
							</div>
                            <div class="field col-12 md:col-2">
                                <label htmlFor="dataRegistro">Data Registro</label>
                                <p-calendar
                                    [(ngModel)]="adicionalEDesconto.dataRegistro"
                                    [readonlyInput]="false"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [showButtonBar]="true"
                                    name="dataRegistro" ngModel
                                    #dataRegistro="ngModel" [required]="true">
                                </p-calendar>
                            </div>
                            <div class="field col-12 md:col-2">
                                <label htmlFor="dataCompetencia">Competência</label>
                                <p-calendar 
                                [(ngModel)]="adicionalEDesconto.dataCompetencia"
                                placeholder="Selecione"
								view="month" 
								dateFormat="mm/yy"
								[showIcon]="true"
								[readonlyInput]="true" 
								name="dataCompetencia" ngModel
								#dataCompetencia="ngModel">
								</p-calendar>
                            </div>
                            <div class="field col-12 md:col-2">
                                <label htmlFor="valorRegistro">Valor</label>
                                <p-inputNumber name="valorRegistro" ngModel #valorRegistro="ngModel" mode="currency"
                                    inputId="currency-brazil" currency="BRL" locale="pt-BR" [allowEmpty]="true"
                                    [required]="true" [(ngModel)]="adicionalEDesconto.valorRegistro">
                                </p-inputNumber>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!loading">
                            <div class="col-12 md:col-4" >
                                <button type="submit" pButton [icon]="progressoRequisicao ? 'pi pi-spin pi-spinner' : 'pi pi-check'" label="Atualizar"
                                        class="p-button-outlined p-button-success md:w-9rem" [disabled]="progressoRequisicao"></button>
                            </div>
                            
                            <div class="col-12 md:col-4 flex justify-content-end">
                                <button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
                                    class="p-button-outlined md:w-9rem" routerLink="/apps/adicionais-e-descontos"></button>
                            </div>
                        </div>
                        </div>
                </form>
            </div>
        </div>
    </div>
    